module.exports = __webpack_public_path__ + "static/Victor-34f5343704012bfbc84ff9dcae85dfb5.jpg";